import React from 'react';
import { block } from '../../utils/cn';
import i18n from './i18n';
import './CaptionRow.css';
import { jsx as _jsx } from "react/jsx-runtime";
var b = block('search-caption-row');
export function CaptionRow(_ref) {
  var item = _ref.item,
    view = _ref.view,
    className = _ref.className;
  var isMobileView = view === 'mobile';
  return /*#__PURE__*/_jsx("div", {
    className: b({
      mobile: isMobileView
    }, className),
    children: i18n(item.layer)
  });
}
// #sourceMappingURL=CaptionRow.js.map